import { AuthenticateWithRedirectCallback } from '@clerk/react';
import { Loader2 } from 'lucide-react';

/**
 * Minimal landing page for Google / SSO OAuth redirects. Clerk handles the
 * session exchange via `AuthenticateWithRedirectCallback`; we just show a
 * branded spinner while the round-trip completes.
 */
export function SsoCallbackPage() {
  return (
    <main
      aria-label="Authenticating"
      className="flex h-[100dvh] w-full items-center justify-center bg-canvas text-primary"
    >
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-accent-lime" aria-hidden="true" />
        <p className="font-mono text-caption uppercase tracking-[0.2em] text-muted">
          Signing you in…
        </p>
      </div>
      {/* The signInUrl/signUpUrl + factor URLs are critical: without them
          Clerk's handleRedirectCallback falls back to the hosted Account
          Portal whenever the signIn isn't `complete` (cancelled OAuth,
          needs_first_factor, abandoned, etc.), stranding the user on
          *.clerk.accounts.dev instead of our own /sign-in. */}
      <AuthenticateWithRedirectCallback
        signInUrl="/sign-in"
        signUpUrl="/sign-up"
        signInFallbackRedirectUrl="/dashboard"
        signUpFallbackRedirectUrl="/getting-started"
        firstFactorUrl="/sign-in"
        secondFactorUrl="/sign-in"
        resetPasswordUrl="/sign-in"
        continueSignUpUrl="/sign-up"
      />
    </main>
  );
}
